import { Label as FplLabel } from '@figma/fpl-components';
import cssVars from '@figma/fpl-tokens/css-vars';
import { color } from '@/colors';
import { StyledInputLabel } from '@/UI/Input/Input';
import { useFplMigrationFlag } from '@/contexts/FplMigrationContext';
import type { ReactNode } from 'react';

interface FieldLabelProps {
  children: NonNullable<ReactNode>;
  htmlFor?: string;
}

export function FieldLabel({ children, htmlFor }: FieldLabelProps) {
  const isFpl = useFplMigrationFlag();

  if (isFpl) {
    return <FplLabel htmlFor={htmlFor}>{children}</FplLabel>;
  }

  // In flow, like the label `Input` renders for itself. Absolute would take the label out of the
  // column and draw it over the top of the very field it names.
  return (
    <StyledInputLabel htmlFor={htmlFor} sx={{ position: 'static', color: color.White80_T }}>
      {children}
    </StyledInputLabel>
  );
}

/**
 * The gap a `FieldLabel` column needs between the label and its field, matching what `Input` leaves
 * for its own label. Legacy labels are taller and carry a -4px lift, so they need less of it.
 */
export function useLabelFieldOffset(): string | number {
  const isFpl = useFplMigrationFlag();
  return isFpl ? cssVars.spacer.x1 : 0.5;
}
